import { useState, useEffect } from 'react'
import { getFactionsExpandAPI } from '../../services/factions'

export default function UseFactionExpand(orgId, divisionId, factionId, departmentId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = { 
      orgId,
      dsId: divisionId,
      searchs
    }
    const getData = async () => {
      const result = await getFactionsExpandAPI(param)
      if (!result) return
      if (result.result) {
        const newData = result.result && result.result.map((d, i) => {
          return {
            value: d.fac_id,
            label: `${d.faction_en} (${d.faction})`,
            data: d.faction_en,

          }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    if (divisionId && orgId ) {
      getData()
    }
  }, [divisionId, orgId])

  return data
}
